export default __webpack_public_path__ + "static/media/party-emoji-right.28e12336.png";